import { Select } from "antd";
import _ from "lodash";
import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import styled from "styled-components";

import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { Icon } from "@components/Icon";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { fetchAPI } from "@utils/https/fetchAPI";
import { VALIDATE_RULES } from "@validate/index";

const FormContainer = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
  margin-top: 6px;
`;

// const SelectDeviceContainer = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 8px;
// `;

const SelectDeviceContainer = styled.div`
  display: grid;
  grid-template-columns: 45% 45% auto;
  gap: 16px;
  align-items: center;
  margin-bottom: 16px;
`;

export const FormCreate = ({
  customerId,
  locationId,
  setDataList = () => undefined,
  setIsModalVisible,
  dataList,
  allDevices,
  deviceNotUsed,
  setDeviceNotUsed,
  // devices,
  campaigns,
}) => {
  const { control, handleSubmit, watch, setValue } = useForm();
  const [groupDetailsLength, setGroupDetailsLength] = useState(1);
  const [deviceSelectedCampaigns, setDeviceSelectedCampaigns] = useState({});
  const [deviceGroups, setDeviceGroups] = useState([
    { device: null, campaign: null },
  ]);

  const devices = _.filter(allDevices, (item, index) => {
    const deviceId = _.get(item, ["value"]);
    return !_.includes(deviceNotUsed, deviceId);
  });

  // const onHandleCreate = async (data) => {
  //   const deviceGroupsDetails = _.chain(new Array(groupDetailsLength))
  //     .map((item, index) => {
  //       const deviceId = watch(`device-${index}`);
  //       const campaign = watch(`campaign-${index}`);
  //       const campaignId = _.get(campaign, ["value"]);
  //       return { device_id: deviceId, advertising_campaigns_id: campaignId };
  //     })
  //     .value();

  //   const deviceGroup = {
  //     name: _.get(data, ["name"]),
  //     category_customer_id: customerId,
  //     location_id: locationId,
  //     type: "SYNCHRONIZED",
  //     offset: _.get(data, ["offset"]),
  //     device_master: _.get(data, ["device_master"]),
  //     status: "ON-AIR",
  //     deviceGroupsDetails,
  //   };

  //   const resp = await fetchAPI({
  //     method: "post",
  //     path: "/api/v1/device-groups/create",
  //     isAuth: true,
  //     data: { deviceGroup },
  //   });

  //   if (_.get(resp, ["status"])) {
  //     const results = _.chain(resp).get(["result"]).value();

  //     const updateDeviceNotUsed = _.chain(results)
  //       .get(["deviceGroupsDetails"])
  //       .map((item, index) => {
  //         return _.get(item, ["device_id"]);
  //       })
  //       .thru((item) => {
  //         return [...item, ...deviceNotUsed];
  //       })
  //       .uniq()
  //       .value();
  //     console.log("results :>> ", results);

  //     setDeviceNotUsed(updateDeviceNotUsed);
  //     toast.success("Create Group Success.");
  //     setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
  //     const updateData = _.chain(dataList)
  //       .thru((list) => {
  //         return [results, ...list];
  //       })
  //       .map((item, index) => {
  //         return { ...item, key: index + 1, index: index + 1 };
  //       })
  //       .value();
  //     setDataList(updateData);
  //   }
  // };

  const onHandleCreate = async (data) => {
    const deviceGroupsDetails = _.map(deviceGroups, (group) => ({
      device_id: group.device,
      advertising_campaigns_id: group.campaign,
    }));

    const deviceGroup = {
      name: _.get(data, ["name"]),
      category_customer_id: customerId,
      location_id: locationId,
      type: "SYNCHRONIZED",
      offset: 0,
      status: "ON-AIR",
      deviceGroupsDetails,
    };

    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/device-groups/create",
      isAuth: true,
      data: { deviceGroup },
    });

    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      const updateDeviceNotUsed = _.uniq([
        ..._.map(results.deviceGroupsDetails, "device_id"),
        ...deviceNotUsed,
      ]);

      setDeviceNotUsed(updateDeviceNotUsed);
      toast.success("Create Group Success.");
      setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
      const updateData = _.map([results, ...dataList], (item, index) => ({
        ...item,
        key: index + 1,
        index: index + 1,
      }));
      setDataList(updateData);
    }
  };

  // const handleCampaignChange = ({ campaignId, index }) => {
  //   const deviceId = watch(`device-${index}`);
  //   const setValueCampaign = _.find(campaigns, (item) => {
  //     return _.get(item, ["value"]) === campaignId;
  //   });
  //   setValue(`campaign-${index}`, setValueCampaign);
  //   const updateDeviceSelectedCampaign = _.chain(deviceSelectedCampaigns)
  //     .cloneDeep()
  //     .thru((item) => {
  //       return _.chain(item)
  //         .update(deviceId, (campaigns) => {
  //           return _.chain(campaigns)
  //             .thru((campaigns) => campaigns || [])
  //             .remove(({ index: i }) => i !== index)
  //             .push({ index, campaignId })
  //             .value();
  //         })
  //         .value();
  //     })
  //     .value();
  //   setDeviceSelectedCampaigns(updateDeviceSelectedCampaign);
  // };

  const handleCampaignChange = ({ campaignId, index }) => {
    const updatedDeviceGroups = _.map(deviceGroups, (group, i) =>
      i === index ? { ...group, campaign: campaignId } : group
    );
    setDeviceGroups(updatedDeviceGroups);
  };

  // const getAvailableCampaigns = ({ index }) => {
  //   const deviceId = watch(`device-${index}`);
  //   const usedCampaigns = _.chain(deviceSelectedCampaigns)
  //     .get([deviceId])
  //     .map((item) => {
  //       return _.get(item, ["campaignId"]);
  //     })
  //     .value();
  //   return _.filter(campaigns, (item) => {
  //     const campaignValue = _.get(item, ["value"]);
  //     return !_.includes(usedCampaigns, campaignValue);
  //   });
  // };

  const getAvailableCampaigns = ({ index }) => {
    // const deviceId = deviceGroups[index].device;
    const deviceId = _.get(deviceGroups, [index, "device"]);
    const deviceCampaignMap = _.reduce(
      deviceGroups,
      (result, group, idx) => {
        if (group.device && group.campaign) {
          result[group.device] = result[group.device] || [];
          result[group.device].push(group.campaign);
        }
        return result;
      },
      {}
    );

    const usedCampaigns = _.get(deviceCampaignMap, [deviceId], []);

    const result = _.filter(campaigns, (item) => {
      const campaignValue = _.get(item, "value");
      return !_.includes(usedCampaigns, campaignValue);
    });

    console.log("result :>> ", result);
    return result;
  };

  const getDeviceMaster = () => {
    const selectedDevices = _.map(deviceGroups, (group) => group.device);
    return _.filter(devices, (device) =>
      _.includes(selectedDevices, device.value)
    );
  };

  // const onHandleDeleteDevice = ({ index }) => {
  //   const updateDeviceSelectedCampaign = _.chain(deviceSelectedCampaigns)
  //     .cloneDeep()
  //     .mapValues((item) => {
  //       return _.filter(item, (filterItem) => {
  //         return _.get(filterItem, ["index"]) !== index;
  //       });
  //     })
  //     .omitBy(_.isEmpty)
  //     .value();
  //   setDeviceSelectedCampaigns(updateDeviceSelectedCampaign);
  //   setGroupDetailsLength((prev) => prev - 1);
  //   setValue(`device-${index}`, null);
  //   setValue(`campaign-${index}`, null);
  // };

  const onHandleDeleteDevice = ({ index }) => {
    setDeviceGroups((prev) => _.filter(prev, (group, i) => i !== index));
    setDeviceSelectedCampaigns((prev) => {
      const updatedCampaigns = _.mapValues(prev, (campaigns) =>
        _.filter(campaigns, ({ index: i }) => i !== index)
      );
      return _.omitBy(updatedCampaigns, _.isEmpty);
    });
  };

  return (
    <FormContainer onSubmit={handleSubmit(onHandleCreate)} autoComplete="off">
      <Line />
      <InnerContainer style={{ overflow: "scroll" }}>
        <div>
          <Controller
            name="name"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Name
                </Text>
                <StyledInput
                  label="name"
                  {...field}
                  size="large"
                  placeholder="name"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />

          {/* <Controller
            name="offset"
            control={control}
            rules={_.get(VALIDATE_RULES, ["numberOnly"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Offset
                </Text>
                <StyledInput
                  label="offset"
                  {...field}
                  size="large"
                  placeholder="offset"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          /> */}

          {/* <Controller
            name={`device_master`}
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div style={{ flex: 1 }}>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Device Master
                </Text>
                <Select
                  {...field}
                  size="large"
                  showSearch
                  placeholder="Select a device master"
                  optionFilterProp="children"
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  disabled={_.isEmpty(getDeviceMaster())}
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={getDeviceMaster()}
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          /> */}

          {/* <Line /> */}

          {/* {_.map(deviceGroups, (group, index) => (
            <SelectDeviceContainer key={index}>
              <div style={{ flex: 1 }}>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Device
                </Text>
                <Select
                  size="large"
                  showSearch
                  placeholder="Select a device"
                  optionFilterProp="children"
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={devices}
                  value={group.device}
                  onChange={(value) => {
                    const updatedDeviceGroups = _.map(deviceGroups, (grp, i) =>
                      i === index
                        ? { ...grp, device: value, campaign: null }
                        : grp
                    );
                    setDeviceGroups(updatedDeviceGroups);
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Campaign
                </Text>
                <Select
                  size="large"
                  showSearch
                  placeholder="Select a campaign"
                  optionFilterProp="children"
                  style={{ flex: 1, width: "100%" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={getAvailableCampaigns({ index })}
                  // value={group.campaign}
                  value={_.chain(campaigns)
                    .find((item) => {
                      return (
                        _.get(item, ["value"]) === _.get(group, ["campaign"])
                      );
                    })
                    .get(["label"])
                    .value()}
                  disabled={!group.device}
                  onChange={(value) =>
                    handleCampaignChange({ campaignId: value, index })
                  }
                />
              </div>
              <Icon
                disabled={index === 0}
                style={{ marginTop: 30 }}
                isCursor
                width={34}
                height={34}
                onClick={() => onHandleDeleteDevice({ index })}
              >
                <ICON_TABLE_DELETE />
              </Icon>
            </SelectDeviceContainer>
          ))} */}

          {/* <ButtonContainer style={{ justifyContent: "end" }}>
            <Button
              style={{ marginTop: 2 }}
              type="button"
              color={COLOR_GREEN}
              fontColor={COLOR_WHITE}
              fontSize="16px"
              padding="5px 20px"
              // onClick={() => setGroupDetailsLength((prev) => prev + 1)}
              onClick={() =>
                setDeviceGroups((prev) => [
                  ...prev,
                  { device: null, campaign: null },
                ])
              }
            >
              Add DeviceInGroups
            </Button>
          </ButtonContainer> */}
        </div>

        <ButtonContainer>
          <Button
            type="submit"
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="5px 20px"
          >
            Save
          </Button>
        </ButtonContainer>
      </InnerContainer>
    </FormContainer>
  );
};
